<rt-dialog-header
  [heading]="'tlc.current_user.password_recovery_email.dialog.header' | translate"
/>

<rt-dialog-body variant="white" layout layout-vertical>
  <span>
    {{ 'tlc.current_user.password_recovery_email.dialog.content' | translate }}
  </span>
  <form [formGroup]="form" margin-top>
    <rt-form-field>
      <rt-label
        >{{ 'tlc.current_user.password_recovery_email.dialog.input_label' | translate }}
      </rt-label>
      <rt-input
        rtProtectedControl
        formControlName="recoveryEmail"
        placeholder="{{
          'tlc.current_user.password_recovery_email.dialog.input_placeholder' | translate
        }}"
        [disabled]="loading()"
      />
    </rt-form-field>
  </form>
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button (click)="close()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button (click)="submit()" [loading]="loading()" variant="primary">
    {{ 'tlc.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
